import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {
  setPrimaryInfo,
  displayProfileModal,
  setProfileModalPage,
} from '../../../modules/profile/actions/creators'

import { doUpdateMissingData } from '../../../controllers/Profile'

import {
  waitRenderServer,
  renderServer,
} from '../../../modules/ssr/actions/creators'

import MissingDataProfilePage from '../components/MissingDataProfilePage/MissingDataProfilePage'

const mapStateToProps = reduxState => {
  const { auth, profile } = reduxState

  const { accessToken } = auth

  const { primaryInfo } = profile

  return {
    accessToken,
    primaryInfo,
    doUpdateMissingData,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setPrimaryInfo,
      displayProfileModal,
      setProfileModalPage,
      waitRenderServer,
      renderServer,
    },
    dispatch,
  )

const ConnectedMissingDataProfilePage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MissingDataProfilePage)

export default ConnectedMissingDataProfilePage
